import * as RadixAccordion from '@radix-ui/react-accordion';
import { ArrowDown } from '@sds-system/assets';
import type { PolymorphicRef } from '@sds-system/types';
import type { ElementType } from 'react';
import { forwardRef } from 'react';
import { Icon } from '../Icon';
import {
  AccordionContent,
  AccordionItem,
  AccordionRoot,
  AccordionTrigger,
} from './Accordion.styled';
import type { AccordionComponent, AccordionProps } from './Accordion.types';

export const Accordion: AccordionComponent = forwardRef(
  <C extends ElementType = 'div'>(
    {
      items,
      value,
      onValueChange,
      width = '100%',
      type = 'single',
      size = 'M',
      activeColor,
      justifyContent = 'space-between',
      gap,
      styledComponents,
      indicator,
      defaultValue,
    }: AccordionProps<C>,
    ref: PolymorphicRef<C>,
  ) => {
    return (
      <>
        {type === 'single' ? (
          <AccordionRoot
            collapsible
            defaultValue={defaultValue}
            onValueChange={onValueChange}
            ref={ref}
            type={'single'}
            value={value}
            width={width}
            {...styledComponents?.root}
          >
            {items.map((item) => (
              <AccordionItem key={item.value} value={item.value}>
                <RadixAccordion.Header>
                  <AccordionTrigger
                    activeColor={activeColor}
                    gap={gap}
                    justifyContent={justifyContent}
                    size={size}
                    {...styledComponents?.trigger}
                  >
                    {item.trigger}
                    {indicator ? (
                      indicator
                    ) : (
                      <Icon className='ArrowDown' size='2XS' source={ArrowDown} />
                    )}
                  </AccordionTrigger>
                </RadixAccordion.Header>
                <AccordionContent>{item.content}</AccordionContent>
              </AccordionItem>
            ))}
          </AccordionRoot>
        ) : (
          <AccordionRoot type={'multiple'} width={width}>
            {items.map((item) => (
              <AccordionItem key={item.value} value={item.value}>
                <RadixAccordion.Header>
                  <AccordionTrigger
                    activeColor={activeColor}
                    justifyContent={justifyContent}
                    size={size}
                    {...styledComponents?.trigger}
                  >
                    {item.trigger}
                    {indicator ? (
                      indicator
                    ) : (
                      <Icon className='ArrowDown' size='2XS' source={ArrowDown} />
                    )}
                  </AccordionTrigger>
                </RadixAccordion.Header>
                <AccordionContent>{item.content}</AccordionContent>
              </AccordionItem>
            ))}
          </AccordionRoot>
        )}
      </>
    );
  },
);
